import { Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

import { InboxService } from '../../../../../../../../services/inbox/inbox.service';
import { InvalidDocument } from '../../../../../../../../models/inbox';
import { dateStringFromISO8601, timeStringFromISO8601 } from '../../../../../../../../utils';
import { AccountService } from '../../../../../../../../services/account/account.service';

enum InvalidDocumentAction {
  dismiss
}

@Component({
  selector: 'app-review-invalid-document-modal',
  templateUrl: './review-invalid-document-modal.component.html',
  styleUrls: ['./review-invalid-document-modal.component.css']
})
export class ReviewInvalidDocumentModalComponent implements OnInit {

  @Input() invalidDocument: InvalidDocument;
  @Input() savedCallback: () => undefined;

  public selectedAction: InvalidDocumentAction = null;

  public loadingSubmit = false;
  public errorMessage = '';

  public serverError: number = null;

  // Create instance references to lookup functions and enums so they may be
  // called in the template.
  public InvalidDocumentAction = InvalidDocumentAction;
  public dateStringFromISO8601 = dateStringFromISO8601;
  public timeStringFromISO8601 = timeStringFromISO8601;

  constructor(
    public accountService: AccountService,
    public activeModal: NgbActiveModal,
    private inboxService: InboxService
  ) {}

  ngOnInit() {
    if (!this.accountService.getMyAccount().can_manage_members) {
      return;
    }
  }

  /**
   * Whether a valid input has been selected. Used to determine whether the
   * save button is clickable.
   */
  public validInputSelected(): boolean {
    return (
      [
        InvalidDocumentAction.dismiss
      ].indexOf(this.selectedAction) >= 0
    );
  }

  public handleSave() {
    this.loadingSubmit = true;

    this.errorMessage = '';

    if (!this.validInputSelected()) {
      this.errorMessage = 'Please choose a valid option.';
      this.loadingSubmit = false;
      return;
    }

    this.inboxService
      .dismissInvalidDocumentInboxItem(this.invalidDocument.id)
      .then(() => {
        this.inboxService.loadInboxCounts(true).then();
        this.savedCallback();
        this.activeModal.close();
      })
      .catch(reason => {
        if (reason.status === 400) {
          this.errorMessage = reason.error;
        } else if (reason.status === 403) {
          this.errorMessage = 'You do not have permission to review invalid documents.';
        } else {
          this.serverError = reason.status;
        }
      })
      .finally();
  }

}
